import { useMutation } from 'react-query';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { ROUTES } from 'constants/routes';
import { ErrorResponse } from 'types/network';

export const usePartnerUpSertMfaPhoneNumber = () => {
  const Axios = useAuthenticatedAxios();
  return useMutation<string, ErrorResponse, { phoneNumber: string }>(
    async ({ phoneNumber }) => {
      const { data } = await Axios({
        method: 'post',
        url: `/${phoneNumber}?route=${ROUTES.PartnerUpSertMfaPhoneNumber}`
      });
      return data;
    }
  );
};
